import { usePreferencesStore } from '../store/preferences-store';

/**
 * Trigger device vibration, gated by the user's vibration preference.
 * Silently no-ops if the device does not support vibration or the
 * preference is disabled.
 */
export function vibrate(pattern: number | number[]): void {
  if (typeof navigator === 'undefined' || !navigator.vibrate) return;
  if (!usePreferencesStore.getState().vibrationEnabled) return;
  navigator.vibrate(pattern);
}
